import React from 'react'

// material ui
import Typography from '@mui/material/Typography'

// shared components
import Section from 'components/atoms/Section'
import OnlineHelpModal from 'components/shared/OnlineHelpModal'

// local components
import Camper from './Camper'

const Campers = props => {
  const {
    title,
    account,
    season,
    enableCovidRequirements,
    subheaderText,
    buttonText,
    buttonRoute,
    reupRequired,
    editable
  } = props

  // get all campers that are confirmed or have an active plan
  const campers = account.campers.filter(
    camper => camper.confirmed || (camper.plans && camper.plans.length > 0)
  )

  return (
    <Section
      title={title}
      subheaderText={subheaderText}
      buttonText={buttonText}
      buttonRoute={buttonRoute}
    >
      <OnlineHelpModal />
      {campers.map(camper => (
        <Camper
          key={camper.id}
          account={account}
          camper={camper}
          season={season}
          enableCovidRequirements={enableCovidRequirements}
          reupRequired={reupRequired}
          editable={editable}
        />
      ))}

      {campers.length > 0 && !enableCovidRequirements && (
        <Typography m={2} variant='body1'>
          *You can always attend any open location. We use preferred location
          for planning and account purposes.
        </Typography>
      )}
    </Section>
  )
}

export default Campers
